import type { StoredSmartSearchPrompt } from '@awazevr/mfe-common.compositions.search-experience'
import type { PropertyClickPayload } from '@awazevr/mfe-common.contexts.tms'

type CreatePropertyClickPayloadArgs = Pick<
  PropertyClickPayload,
  'propertyCode' | 'searchCriteria' | 'searchData'
> & {
  smartSearchPrompt?: StoredSmartSearchPrompt
}

export const createPropertyClickPayload = ({
  propertyCode,
  searchCriteria,
  searchData,
  smartSearchPrompt,
}: CreatePropertyClickPayloadArgs): PropertyClickPayload => ({
  propertyCode,
  searchCriteria,
  searchData,
  promptId: smartSearchPrompt?.promptId,
  smartSearchVersion: smartSearchPrompt?.smartSearchVersion,
  promptFacets: smartSearchPrompt?.promptFacets,
})
